import React, { Component } from "react";
import { Card, Container, Badge, Button, Spinner } from "react-bootstrap";
import gql from "graphql-tag";
import { withRouter } from "react-router-dom";
import compose from "lodash.flowright";
import { graphql } from "react-apollo";
import "./_pdf.scss";

const FETCH_QUESTIONS = gql`
  query GetQuestions($id: Int!) {
    getAIMLFiles(id: $id) {
      file_name
      questions {
        id
        question
        option1
        option2
        option3
        option4
        answer
        explanation
        subject
        chapter
        topic
      }
    }
  }
`;

class PdfQuestionsSec extends Component {

  decodeHTML = (text) => decodeURIComponent(text || "");

  renderHTML = (text) => ({
    __html: this.decodeHTML(text)
  });

  goBack = () => {
    this.props.history.push("/settings/PDF_upload");
  };

  render() {

    const { loading, error, getAIMLFiles } = this.props.data;

    /* ---------------- LOADING ---------------- */

    if (loading) {
      return (
        <div style={{
          height: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column"
        }}>
          <Spinner animation="border" variant="primary" />
          <div className="mt-2">Loading Questions...</div>
        </div>
      );
    }

    /* ---------------- ERROR ---------------- */

    if (error) {
      return (
        <div style={{
          height: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          color: "red"
        }}>
          <h5>⚠ Error loading questions</h5>
          <p>{error.message}</p>
        </div>
      );
    }

    const pdf = getAIMLFiles?.[0] || {};
    const questions = pdf.questions || [];

    return (

      <Container  className="mt-3">

        {/* ---------------- HEADER CARD ---------------- */}

        <Card className="mb-4 shadow-sm">

          <Card.Body className="d-flex justify-content-between align-items-center">

            <div>

              <h5 style={{ marginBottom: "5px" }}>
                📄 {pdf.file_name}
              </h5>

              <small style={{ color: "#666" }}>
                Total Questions: {questions.length}
              </small>

            </div>

            <Button
              variant="secondary"
              onClick={this.goBack}
            >
              ← Back
            </Button>

          </Card.Body>

        </Card>

        {/* ---------------- QUESTIONS ---------------- */}

        {questions.length === 0 && (
          <Card className="p-4 text-center">
            No Questions Found
          </Card>
        )}

        {questions.map((q, index) => (

          <Card
            className="mb-4 shadow-sm"
            key={q.id}
          >

            <Card.Body>

              {/* Subject Chapter Topic */}
              <div className="d-flex justify-content-between align-items-start mb-2">

                <b style={{ color: "#d62828", fontSize: "16px" }}>
                  Q{index + 1}
                </b>

                <i
                  className="fas fa-edit text-primary"
                  style={{ cursor: "pointer", fontSize: "16px" }}
                  onClick={() => this.editQuestion(q)}
                ></i>

              </div>
              
              <div className="mb-3">

                <span className="badge bg-primary me-2">
                  Subject:
                  <span dangerouslySetInnerHTML={this.renderHTML(q.subject)} />
                </span>

                <span className="badge bg-success me-2">
                  Chapter:
                  <span dangerouslySetInnerHTML={this.renderHTML(q.chapter)} />
                </span>

                <span className="badge bg-warning text-dark">
                  Topic:
                  <span dangerouslySetInnerHTML={this.renderHTML(q.topic)} />
                </span>

              </div>

              {/* Question */}

              <div style={{ fontSize: "15px", marginBottom: "10px" }}>
                <span dangerouslySetInnerHTML={this.renderHTML(q.question)} />
              </div>

              {/* Options */}

              <div className="row mt-3">

                {q.option1 && (
                  <div className="col-md-6 mb-2">
                    <b>A.</b>
                    <span dangerouslySetInnerHTML={this.renderHTML(q.option1)} />
                  </div>
                )}

                {q.option2 && (
                  <div className="col-md-6 mb-2">
                    <b>B.</b>
                    <span dangerouslySetInnerHTML={this.renderHTML(q.option2)} />
                  </div>
                )}

                {q.option3 && (
                  <div className="col-md-6 mb-2">
                    <b>C.</b>
                    <span dangerouslySetInnerHTML={this.renderHTML(q.option3)} />
                  </div>
                )}

                {q.option4 && (
                  <div className="col-md-6 mb-2">
                    <b>D.</b>
                    <span dangerouslySetInnerHTML={this.renderHTML(q.option4)} />
                  </div>
                )}

              </div>

              {/* Answer */}

              <div
                style={{
                  marginTop: "15px",
                  background: "#e8f5e9",
                  padding: "10px",
                  borderRadius: "6px"
                }}
              >
                <b>Answer:</b> {q.answer}
              </div>

              {/* Explanation */}

              <div style={{ marginTop: "10px" }}>

                <b>Explanation:</b>

                <div
                  dangerouslySetInnerHTML={this.renderHTML(q.explanation)}
                />

              </div>

            </Card.Body>

          </Card>

        ))}

      </Container>

    );

  }

}

export default compose(

  withRouter,

  graphql(FETCH_QUESTIONS, {
    options: (props) => {

      const id =
        props.match && props.match.params
          ? parseInt(props.match.params.id)
          : 0;

      return {
        variables: { id }
      };

    }
  })

)(PdfQuestionsSec);